import {
  extractOrderProductConfigItemsFromFullConfig,
  getConcatCpoColorValue,
  separateConfigItemsByType,
} from "view/apps/Supplier/pages/Products/List/components/ProductDetailsDrawer/components/CustomProductOptionConfigModal/CustomProductOptionConfigItemForm/utills/helpers";
import { CpoConfigById } from "store/custom-product-option/custom-product-option-configs.store";
import { OrderProductCpoConfig } from "ts/api/order";

export const getCpoValue = (
  configById?: CpoConfigById,
  cpoConfig?: OrderProductCpoConfig
): string => {
  if (!cpoConfig || !configById) {
    return "";
  }
  const config = configById.get(cpoConfig.id);
  if (!config) {
    return "";
  }

  const { colorItems } = separateConfigItemsByType(
    extractOrderProductConfigItemsFromFullConfig(config, cpoConfig)
  );

  const regularItemName = cpoConfig.items
    .reduce<string[]>((acc, item) => {
      if (!colorItems.some((c) => c.id === item.id)) {
        acc.push(item.name);
      }

      return acc;
    }, [])
    .join("; ");
  const baseColorName = getConcatCpoColorValue(colorItems);
  const colorName =
    baseColorName && regularItemName ? `${baseColorName}; ` : baseColorName;

  return `(${colorName}${regularItemName})`;
};
